/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const AreaCreatePage = lazyLoad(
  () => import('./index'),
  module => module.AreaCreatePage
);
